import React, {useEffect, useState} from "react";
import {Modal, Row, Col} from "react-bootstrap";
import userImage from "../assets/user.png"
import ApiService from "../ApiService";
import { BsX, BsTelephoneFill, BsGeoAltFill } from "react-icons/bs";
import {format_yyyy_mm_dd_to_DATETIME_MED} from "../util/common";
import Image from 'react-bootstrap/Image'

const PatientProfileModal = props => {
    const [profilePic, setProfilePic] = useState(null);
    const [loading, setLoadingStatus] = useState(false);
    const fetchUserProfilePic = async() => {
        setLoadingStatus(true);
        try{
            if (props.user.userId) {
                const imageData = await ApiService.getUserProfilePicById(props.user.userId);
                setProfilePic(imageData.data);
            }
        } catch(e){
            setProfilePic(null);
        } finally {
            setLoadingStatus(false);
        }
    }
    useEffect(() => {
        fetchUserProfilePic();
    }, [props.user]);
    
    return (
        <Modal show={props.show} onHide={props.onHideModal} backdrop="static" aria-labelledby="contained-modal-title-vcenter"
        centered>
            <Modal.Header id="modalHeader">
                    <Row>
                        <Col md={3}>
                            <div>
                            {
                                !loading?
                                profilePic ?
                                    <Image roundedCircle className="profile-pic" alt={"profile pic of " + props.patientName} src={profilePic}/>
                                    :
                                    <Image roundedCircle className="profile-pic" alt={"TBD user "} src={userImage}/>
                                    :
                                    <p>Loading...</p>
                            }
                            </div>
                        </Col>
                        <Col md={8}>
                            <div className="userName">
                                {props.user?.name}
                            </div>
                            <div>
                                <BsGeoAltFill /> {props.user?.address?.locality}, {props.user?.address?.region}
                            </div>
                        </Col>
                        <Col md={1}>
                            <BsX className="pointer" onClick={props.onHideModal}/>
                        </Col>
                    </Row>
                </Modal.Header>
            <Modal.Body id="modalBody">
                <Row>
                    <Col>
                        <span className="modelLabel">Pronouns:</span> {props.user?.pronoun || 'unknown'}
                    </Col>
                    <Col>
                        <span className="modelLabel">DOB:</span> {format_yyyy_mm_dd_to_DATETIME_MED(props.user?.dob)}
                    </Col>
                </Row>
                <Row>
                    <Col>
                    <span className="modelLabel">Address:</span> {props.user?.address?.street_address}
                                {props.user?.address?.locality}, {props.user?.address?.region} {props.user?.address?.postal_code}
                    </Col>
                    <Col>
                        <span className="modelLabel">Phone:</span> {props.user?.phoneNumber}
                    </Col>
                </Row>
                <hr></hr>
                <Row>
                    <Col>
                        <span className="modelLabel">Allergies:</span> {props.user?.allergies}
                    </Col>
                    <Col>
                        <span className="modelLabel">Symptoms:</span> {props.user?.symptoms}
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <span className="modelLabel">Medication:</span> {props.user?.medication}
                    </Col>
                    <Col>
                        <span className="modelLabel">Sex at birth:</span> {props.user?.genderAtBirth}
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    )
};

export default PatientProfileModal;
